import ListTemplate from "components/ListTemplate";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import Filters from "./Filters";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";

const ShowListExternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowListExternalFrontModel>();

  return <>
    <FlightApp />
    <TrainModal />
    <ListTemplate
      title={site.currentEnvironment.show.plural}
      filterSet="show_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Show.PaginatedExternalEnvironment}
      getId={item => item.showId}
      layout={cardLayout(viewModel)}
      filters={<Filters />}
      options={{
        exportOptions: {
          canExportList: site.permissions.show.canExportList,
          exportOptionsApi: window.CoreApi.Show.ExportOptionsForListExternalEnvironment
        }
      }}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
      onEdit={item => window.location.href = routes.show_Edit(item.showId).absolute}
    />
  </>
};

export default ShowListExternalApp;
